module.exports = __webpack_public_path__ + "static/img/Thank.7190a28.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Thank.svg
// module id = ZP1w
// module chunks = 1